/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateDefinitionDto,
  CreateUpdateNumericQuantityDto,
  DefinitionDto,
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100ForbiddenException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100NotFoundException,
  ErrorResponseOfPtw100UnauthorizedException,
  GetDefinitionCatalogs200Response,
  HistoryDto,
  NumericQuantityDto,
  ODataPostProcessedResultsOfNumericQuantityDto,
} from '../models/index';
import {
    CreateDefinitionDtoFromJSON,
    CreateDefinitionDtoToJSON,
    CreateUpdateNumericQuantityDtoFromJSON,
    CreateUpdateNumericQuantityDtoToJSON,
    DefinitionDtoFromJSON,
    DefinitionDtoToJSON,
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100ForbiddenExceptionFromJSON,
    ErrorResponseOfPtw100ForbiddenExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100NotFoundExceptionFromJSON,
    ErrorResponseOfPtw100NotFoundExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    GetDefinitionCatalogs200ResponseFromJSON,
    GetDefinitionCatalogs200ResponseToJSON,
    HistoryDtoFromJSON,
    HistoryDtoToJSON,
    NumericQuantityDtoFromJSON,
    NumericQuantityDtoToJSON,
    ODataPostProcessedResultsOfNumericQuantityDtoFromJSON,
    ODataPostProcessedResultsOfNumericQuantityDtoToJSON,
} from '../models/index';

export interface CreateNumericQuantityRequest {
    createUpdateNumericQuantityDto?: CreateUpdateNumericQuantityDto;
}

export interface DeleteNumericQuantityRequest {
    id: string;
}

export interface GetDefinitionCatalogRequest {
    id: string;
}

export interface GetDefinitionCatalogsRequest {
    requestBody?: Array<string>;
}

export interface GetNumericQuantityRequest {
    id: string;
}

export interface GetNumericQuantityListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetQuantityHistoryRequest {
    id: string;
}

export interface UpdateNumericQuantityRequest {
    id: string;
    createUpdateNumericQuantityDto?: CreateUpdateNumericQuantityDto;
}

export interface ValidateDefinitionRequest {
    createDefinitionDto?: CreateDefinitionDto;
}

export interface ValidateDefinitionWithValueSetsRequest {
    createDefinitionDto?: CreateDefinitionDto;
}

export interface ValidateNumericQuantityRequest {
    createUpdateNumericQuantityDto?: CreateUpdateNumericQuantityDto;
}

/**
 * 
 */
export class NumericQuantitiesApi extends runtime.BaseAPI {

    /**
     * Adds a new entity
     */
    async createNumericQuantityRaw(requestParameters: CreateNumericQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/numeric-quantities`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateNumericQuantityDtoToJSON(requestParameters['createUpdateNumericQuantityDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 201: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => NumericQuantityDtoFromJSON(jsonValue), "NumericQuantityDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => NumericQuantityDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Adds a new entity
     */
     async createNumericQuantity(requestParameters: CreateNumericQuantityRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<NumericQuantitiesApi['createNumericQuantityRaw']>>, NumericQuantityDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = NumericQuantityDto;

         const response = this.createNumericQuantityRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Deletes the entity with the given id.
     */
    async deleteNumericQuantityRaw(requestParameters: DeleteNumericQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteNumericQuantity().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/numeric-quantities/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Deletes the entity with the given id.
     */
     async deleteNumericQuantity(requestParameters: DeleteNumericQuantityRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<NumericQuantitiesApi['deleteNumericQuantityRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.deleteNumericQuantityRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the definition catalog of the given numeric quantity.
     */
    async getDefinitionCatalogRaw(requestParameters: GetDefinitionCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getDefinitionCatalog().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/numeric-quantities/{id}/definition-catalog`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DefinitionDtoFromJSON), "DefinitionDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DefinitionDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     * Returns the definition catalog of the given numeric quantity.
     */
     async getDefinitionCatalog(requestParameters: GetDefinitionCatalogRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<NumericQuantitiesApi['getDefinitionCatalogRaw']>>, Array<DefinitionDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<DefinitionDto>;

         const response = this.getDefinitionCatalogRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the definition catalogs of the given numeric quantities.
     */
    async getDefinitionCatalogsRaw(requestParameters: GetDefinitionCatalogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/numeric-quantities/definition-catalog`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => GetDefinitionCatalogs200ResponseFromJSON(jsonValue), "GetDefinitionCatalogs200Response" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => GetDefinitionCatalogs200ResponseFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns the definition catalogs of the given numeric quantities.
     */
     async getDefinitionCatalogs(requestParameters: GetDefinitionCatalogsRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<NumericQuantitiesApi['getDefinitionCatalogsRaw']>>, GetDefinitionCatalogs200Response>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = GetDefinitionCatalogs200Response;

         const response = this.getDefinitionCatalogsRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns one entity for detail view.
     */
    async getNumericQuantityRaw(requestParameters: GetNumericQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getNumericQuantity().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/numeric-quantities/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => NumericQuantityDtoFromJSON(jsonValue), "NumericQuantityDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => NumericQuantityDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns one entity for detail view.
     */
     async getNumericQuantity(requestParameters: GetNumericQuantityRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<NumericQuantitiesApi['getNumericQuantityRaw']>>, NumericQuantityDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = NumericQuantityDto;

         const response = this.getNumericQuantityRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the catalog of all numeric quantities.
     */
    async getNumericQuantityCatalogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/numeric-quantities/catalog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NumericQuantityDtoFromJSON), "NumericQuantityDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NumericQuantityDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     * Returns the catalog of all numeric quantities.
     */
     async getNumericQuantityCatalog(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<NumericQuantitiesApi['getNumericQuantityCatalogRaw']>>, Array<NumericQuantityDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<NumericQuantityDto>;

         const response = this.getNumericQuantityCatalogRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns a list of entities for grid view.
     */
    async getNumericQuantityListRaw(requestParameters: GetNumericQuantityListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        if (requestParameters['$filter'] != null) {
            queryParameters['$filter'] = requestParameters['$filter'];
        }

        if (requestParameters['$search'] != null) {
            queryParameters['$search'] = requestParameters['$search'];
        }

        if (requestParameters['$top'] != null) {
            queryParameters['$top'] = requestParameters['$top'];
        }

        if (requestParameters['$skip'] != null) {
            queryParameters['$skip'] = requestParameters['$skip'];
        }

        if (requestParameters['$orderby'] != null) {
            queryParameters['$orderby'] = requestParameters['$orderby'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/numeric-quantities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfNumericQuantityDtoFromJSON(jsonValue), "ODataPostProcessedResultsOfNumericQuantityDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfNumericQuantityDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns a list of entities for grid view.
     */
     async getNumericQuantityList(requestParameters: GetNumericQuantityListRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<NumericQuantitiesApi['getNumericQuantityListRaw']>>, ODataPostProcessedResultsOfNumericQuantityDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = ODataPostProcessedResultsOfNumericQuantityDto;

         const response = this.getNumericQuantityListRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the change history of the given numeric quantity.
     */
    async getQuantityHistoryRaw(requestParameters: GetQuantityHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getQuantityHistory().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/numeric-quantities/{id}/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON), "HistoryDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     * Returns the change history of the given numeric quantity.
     */
     async getQuantityHistory(requestParameters: GetQuantityHistoryRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<NumericQuantitiesApi['getQuantityHistoryRaw']>>, Array<HistoryDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<HistoryDto>;

         const response = this.getQuantityHistoryRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Updates an entity, if existing
     */
    async updateNumericQuantityRaw(requestParameters: UpdateNumericQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateNumericQuantity().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/numeric-quantities/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateNumericQuantityDtoToJSON(requestParameters['createUpdateNumericQuantityDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => NumericQuantityDtoFromJSON(jsonValue), "NumericQuantityDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => NumericQuantityDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Updates an entity, if existing
     */
     async updateNumericQuantity(requestParameters: UpdateNumericQuantityRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<NumericQuantitiesApi['updateNumericQuantityRaw']>>, NumericQuantityDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = NumericQuantityDto;

         const response = this.updateNumericQuantityRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Validates a definition, ignoring its value sets.
     */
    async validateDefinitionRaw(requestParameters: ValidateDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/numeric-quantities/definition-validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDefinitionDtoToJSON(requestParameters['createDefinitionDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Validates a definition, ignoring its value sets.
     */
     async validateDefinition(requestParameters: ValidateDefinitionRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<NumericQuantitiesApi['validateDefinitionRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.validateDefinitionRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Validates a definition including its value sets.
     */
    async validateDefinitionWithValueSetsRaw(requestParameters: ValidateDefinitionWithValueSetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/numeric-quantities/definition-value-sets-validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDefinitionDtoToJSON(requestParameters['createDefinitionDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Validates a definition including its value sets.
     */
     async validateDefinitionWithValueSets(requestParameters: ValidateDefinitionWithValueSetsRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<NumericQuantitiesApi['validateDefinitionWithValueSetsRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.validateDefinitionWithValueSetsRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Validates a numeric quantity, including its definitions, without adding or updating it.
     */
    async validateNumericQuantityRaw(requestParameters: ValidateNumericQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/numeric-quantities/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateNumericQuantityDtoToJSON(requestParameters['createUpdateNumericQuantityDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Validates a numeric quantity, including its definitions, without adding or updating it.
     */
     async validateNumericQuantity(requestParameters: ValidateNumericQuantityRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<NumericQuantitiesApi['validateNumericQuantityRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.validateNumericQuantityRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
